import { GameContext } from '../../../../contexts/GameContext';
import { Modal } from 'react-bootstrap';
import { ZdarKidsGameContext } from '../../../../contexts/ZdarKidsGameContext';
import { ZdarKidsGameStepConfiguration } from '../../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import { useLottie } from 'lottie-react';
import Button from '../../../common/buttons/Button';
import React, { useContext } from 'react';
import solutionAnimation from '../../../../assets/images/games/zdar-kids-game/puzzle.json';

type Props = {
    takeHint: () => void;
};
export default function ZdarKidsSolutionModal({ takeHint }: Props) {
    const { solutionModalOpen, setSolutionModalOpen, setSolutionModalEnabled } = useContext(ZdarKidsGameContext);
    const { stepContent, selectHint } = useContext(GameContext);

    const { points } = stepContent as ZdarKidsGameStepConfiguration;
    const text = points
        ? 'Chcete zobrazit řešení úlohy? Za úlohu nezískáte žádné mince.'
        : 'Nevíte si rady a chcete pomoct?';

    const handleShowSolution = () => {
        selectHint();
        takeHint();
        setSolutionModalEnabled(false);
        setSolutionModalOpen(false);
    };
    return (
        <React.Fragment>
            <Modal
                dialogClassName="zdar-kids-solution-modal"
                show={solutionModalOpen}
                onHide={() => setSolutionModalOpen(false)}
            >
                <Modal.Header>
                    <Modal.Title>Řešení</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="solution-modal-animation">
                        <SolutionImage />
                    </div>
                    <div>{text}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="secondary-button" onClick={handleShowSolution}>
                        Ano
                    </Button>
                    <Button className="secondary-button" onClick={() => setSolutionModalOpen(false)}>
                        Ne
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

const SolutionImage = () => {
    const options = {
        animationData: solutionAnimation,
        loop: true,
        autoplay: true,
    };

    const { View } = useLottie(options);

    return View;
};
